export default __webpack_public_path__ + "static/media/text.d429c0a8.svg";